module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Da-Ea.788400da.png";